<template>
  <span
    :class="avatarClass"
    :style="avatarStyle"
  >
    <img
      v-if="src"
      alt
      :src="src"
    />
    <rt-icon
      v-else-if="iconName"
      :name="iconName"
      :color="iconColor"
      :size="computedIconSize"
    />
    <span
      v-else
      :style="textStyle"
    >
      <slot />
    </span>
    <slot name="badge">
      <rt-badge
        v-if="badgeText"
        :value="badgeText"
        :type="type"
      />
    </slot>
  </span>
</template>

<script>
import colors from './defined-colors';
import RtIcon from '../icon/rtIcon.vue';
import RtBadge from '../badge/rtBadge.vue';

export default {
  name: 'RtAvatar',
  components: { RtIcon, RtBadge },
  props: {
    isDot: Boolean,

    shape: {
      type: String,
      default: 'circle',
      validator (val) {
        return ['circle', 'square'].includes(val);
      }
    },
    size: {
      type: [Number, String],
      default: 'large',
      validator (val) {
        if (typeof val === 'string') {
          return ['large', 'medium', 'small'].includes(val);
        }
        return typeof val === 'number';
      }
    },
    type: {
      type: String,
      default: colors.Danger,
      validator (value) {
        return colors.includes(value);
      }
    },
    effect: {
      type: String,
      default: 'dark',
      validator (value) {
        return ['dark', 'light'].includes(value);
      }
    },
    border: Boolean,
    backgroundColor: String,
    // 图片
    src: {
      type: String
    },
    // 图标
    iconName: String,
    // 徽章
    badgeText: Number,
    // 可自定义的内容
    iconSize: [String, Number],
    iconColor: String,
    textSize: Number,
    textColor: String
  },
  data () {
    return {};
  },
  computed: {
    computedIconSize () {
      const { iconSize, size } = this;
      let computedIconSize = null;
      // 存在iconSize
      if (iconSize) {
        computedIconSize = iconSize;
      } else {
      // 不存在iconSize,根据size判断
        if (size === 'large') {
          computedIconSize = 36;
        } else if (size === 'medium') {
          computedIconSize = 24;
        } else if (size === 'small') {
          computedIconSize = 20;
        } else {
          computedIconSize = size;
        }
      }

      return computedIconSize;
    },
    avatarStyle () {
      const { size, backgroundColor } = this;

      let style = {};

      if (size) {
        style.width = style.height = style.lineHeight = `${size}px`;
      }

      if (backgroundColor) {
        style.backgroundColor = backgroundColor;
      }

      return style;
    },
    avatarClass () {
      const { size, type, effect, shape, border } = this;

      let classList = ['rt-avatar'];

      if (size && typeof size === 'string') {
        classList.push(`rt-avatar--${size}`);
      }

      if (shape) {
        classList.push(`rt-avatar--${shape}`);
      }

      if (type) {
        classList.push(`rt-avatar--${type}`);
      }

      if (effect) {
        classList.push(`rt-avatar--${effect}`);
      }

      if (border) {
        classList.push(`rt-avatar--border`);
      }
      return classList.join(' ');
    },
    textStyle () {
      const { textSize, textColor } = this;

      let style = {};
      if (textSize) {
        style.fontSize = textSize + 'px';
      }
      if (textColor) {
        style.color = textColor;
      }

      return style;
    },
    badgeSize () {
      const { size } = this;

      let badgeSize = null;

      const sizeType = typeof size;
      if (sizeType === 'string') {
        if (size === 'large') {
          badgeSize = 'large';
        } else {
          badgeSize = 'medium';
        }
      }
      return badgeSize;
    }
  },
  methods: {}
};
</script>



// WEBPACK FOOTER //
// rtAvatar.vue?6ca0eea0